import { useState } from 'react'
import { twMerge } from 'tailwind-merge'
import { WebGlobe } from '@/assets/icons'

export function AgentV2WebSourceIcon({ url, className }: { url: string; className?: string }) {
  // Reference URLs are validated at the API boundary. Request only the public host's
  // conventional icon, never the cited page path or query string.
  const faviconUrl = `https://${new URL(url).hostname}/favicon.ico`
  return <WebSourceIconImage key={faviconUrl} faviconUrl={faviconUrl} className={className} />
}

function WebSourceIconImage({ faviconUrl, className }: { faviconUrl: string; className?: string }) {
  const [loaded, setLoaded] = useState(false)
  const [failed, setFailed] = useState(false)

  return (
    // The chat response reset forces spans to baseline, so preserve the intended middle alignment.
    // Callers can override alignment via className (twMerge); chat markdown uses text-bottom.
    <span aria-hidden="true" className={twMerge('relative inline-block shrink-0 !align-middle !-translate-y-[2px] h-4 w-4', className)}>
      {!loaded && <WebGlobe className="absolute inset-0 h-full w-full" />}
      {!failed && (
        <img
          src={faviconUrl}
          alt=""
          referrerPolicy="no-referrer"
          loading="lazy"
          decoding="async"
          className={`absolute inset-0 h-full w-full object-contain ${loaded ? '' : 'opacity-0'}`}
          onLoad={() => setLoaded(true)}
          onError={() => {
            setLoaded(false)
            setFailed(true)
          }}
        />
      )}
    </span>
  )
}
